import { observer } from 'mobx-react-lite';
import { errorMediaAttachment } from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { VideoPreviewState } from 'owa-sxsdata';

export interface VideoPreviewProps {
    className?: string;
    onError: (message: string, error?: Error) => void;
    onLoad: () => void;
    viewState: VideoPreviewState;
}

const styles = require('./AudioPreview.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function VideoPreview(props: VideoPreviewProps) {
    const onVideoElementChanged = (videoElement: HTMLVideoElement) => {
        if (videoElement) {
            videoElement.addEventListener('error', onError);
            videoElement.addEventListener('loadeddata', onLoad);
        }
    };
    const onLoad = () => {
        props.onLoad();
    };
    const onError = () => {
        props.onError(loc(errorMediaAttachment), new Error('Video fails to load'));
    };
    const mainClassNames = classNames(props.className, styles.container);
    return (
        <div className={mainClassNames}>
            <span />
            <video
                src={props.viewState.previewUrl}
                controls={true}
                autoPlay={true}
                ref={onVideoElementChanged}
            />
        </div>
    );
});
